module.exports = __webpack_public_path__ + "static/media/mytrees-site.c3493316.png";